export default (res: any) => res;
